import React from 'react';
import { ClarovideoLogo } from '../../../../components/ClarovideoLogo';
import './style.scss';

export const UserSuspendedHeader = () => {
  return (
    <div className="user-suspended-header">
      <ClarovideoLogo
        width={154.76}
        height={30.54}
        classNames="user-suspended-logo"
      />
    </div>
  );
};
